import React from 'react';
import ValidationReason from '../../ValidationReason';
import { withStyles } from '@material-ui/core';
import DuplicateCustomers from '../../../../../../../modules/Reports/DuplicateCustomers';
import appConstants from '../../../../../../../../appConstants';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%'
  },
  duplicateCustomersContainer: {
    flex: 1,
    border: `1px solid ${theme.AppBGColor}`,
    borderRadius: 4
  },
  gridContainer: {
    padding: 0,
    paddingTop: 5
  }
});

const DuplicateCustomersValidation = ({ classes, data, glEventHub, currentStepMessage }) => {
  const filterCustomerIds = data?.map(({ customerID }) => customerID);
  return (
    <div className={classes.container}>
      <ValidationReason message={currentStepMessage} />
      <div className={classes.duplicateCustomersContainer}>
        <DuplicateCustomers
          mode={appConstants.DUPLICATE_CUSTOMER_MODES.DYNAMIC_ROUTING}
          filterCustomers={filterCustomerIds}
          glEventHub={glEventHub}
          disableHeaderActions
          customClasses={{
            gridContainer: classes.gridContainer
          }}
        />
      </div>
    </div>
  );
};

export default withStyles(styles)(DuplicateCustomersValidation);
